<template>
  <div
    v-show="show"
    id=""
    class="flex bottom-16 left-4 absolute bg-white rounded-lg shadow"
    style="z-index:1"
  >
    <b-dropdown
      aria-role="list"
      :can-close="['escape']"
      :mobile-modal="false"
      class="control dropdown is-hoverable is-up"
    >
      <template #trigger="{ active }">
        <button
          aria-haspopup="true"
          class="bg-zonnegrens-primary px-4 py-2 text-white rounded-l-lg flex items-center"
        >
          <i class="mdi mdi-table pr-2" />
          <span class="is-hidden-mobile">{{ $t("attributes") }}</span>
          <i :class="{'mdi mdi-menu-down pl-2': active, 'mdi mdi-menu-up pl-2': !active}" />
        </button>
      </template>

      <b-dropdown-item
        custom
        aria-role="listitem"
      >
        <table
          class="table is-fullwidth is-striped has-text-left"
          style="margin-bottom: 0.75rem"
        >
          <thead>
            <tr>
              <th>{{ $t("attribute") }}</th>
              <th>{{ $t("value") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Maaiveldhoogte</td>
              <td><code style="color:inherit">{{ building.attributes["h_maaiveld"] }} mNAP</code></td>
            </tr>           
            <tr>
              <td>Daktype</td>
              <td><code style="color:inherit">{{ building.attributes["dak_type"] }}</code></td>
            </tr>
            <tr>
              <td>Databron</td>
              <td><code style="color:inherit">{{ building.attributes["pw_bron"] }}</code></td>
            </tr>      
            <tr>
              <td>Datum</td>
              <td><code style="color:inherit">{{ building.attributes["pw_datum"] }}</code></td>
            </tr>                                    
            <tr>
              <td>ID (BAG)</td>
              <td><code style="color:inherit">{{ building.attributes["identificatie"] }}</code></td>
            </tr>      
          </tbody>
        </table>

        <p>
          <a
            class="tag is-danger w-full py-4"
            @click="$emit('report-data')"
          >{{ $t("viewer.issue") }}</a>
        </p>
      </b-dropdown-item>
    </b-dropdown>
    <div class="flex">
      <b-button
        :style="'border-radius: 0; border:0'"
        type="is-static"
        :icon-left="'arrow-expand-vertical'"
      >
        <b class="px-1">{{ h_clicked }}</b> m
      </b-button>
    </div>
    <div class="flex">
      <b-button
        :style="'border-radius: 0 5px 5px 0;border:0'"
        type="is-static"
        :icon-left="'angle-acute'"
      >
        <b class="px-1">{{ azimuthAngle }}</b> °
      </b-button>
    </div>
  </div>
</template>

<script>
export default {

	name: 'BuildingInformation',

	props: {
		show: {
			type: Boolean,
			default: false
		},
		building: {
			type: Object,
			default() {

				return {

					pz: 0,
					batchID: '-999'

				};

			}
		}
	},

	data: function () {

		return {
			attr_names: [ 'identificatie', 'h_maaiveld', 'h_dak_70p', 'dak_type', 'pw_bron', 'pw_datum', 'val3dity_codes' ],
			showAttributes: false
		};

	},

	computed: {

		h_clicked: function () {

			if ( this.building.pz ) return this.building.pz.toFixed( 1 );
			return null;

		},

		azimuthAngle: function () {

			if ( this.building.azimuthAngle !== undefined ) {

				return this.building.azimuthAngle.toFixed( 1 );

			}

			return '-';

		}

	},

	methods: {

		closeInfo() {

			this.$emit( 'close-info' );

		}

	}
};
</script>
